export default function CustomerUpdateController(
  $window,
  $state,
  $stateParams,
  customersService,
  countryService,
  domainService,
  NotificationService,
  notificationHelper,
  POINT_STATUSES,
) {
  const vm = this;

  vm.pointStatuses = POINT_STATUSES;
  vm.customerId = $stateParams.customerId;
  vm.isLoading = false;
  vm.customer = {};
  vm.customerPoints = [];
  vm.customerReservations = [];
  vm.customerRedemptionErrors = [];
  vm.customerPointsTotal = 0;
  vm.customerReservationsTotal = 0;
  vm.customerRedemptionErrorsTotal = 0;
  vm.accountBalance = 0;
  vm.redemptionBalance = 0;
  vm.maxSize = 5;
  vm.reservationsOffset = 0;
  vm.pointsOffset = 0;
  vm.redemptionErrorsOffset = 0;
  vm.limit = 100;
  vm.currentPointsPage = 1;
  vm.currentReservationsPage = 1;
  vm.currentRedemptionErrorsPage = 1;

  vm.options = {
    salutations: [],
    countries: [],
    locales: [],
  };

  vm.tabs = {
    reservations: true,
    points: false,
    redemptionErrors: false,
  };

  vm.init = init;
  vm.selectTab = selectTab;
  vm.deselectTab = deselectTab;
  vm.getSalutations = getSalutations;
  vm.updateCustomer = updateCustomer;
  vm.deleteCustomer = deleteCustomer;
  vm.reservationsPageChanged = reservationsPageChanged;
  vm.pointsPageChanged = pointsPageChanged;
  vm.redemptionErrorsPageChanged = redemptionErrorsPageChanged;

  init();

  function init() {
    getCountries();
    getCustomerById();
    if ($stateParams.tab) {
      return vm.selectTab($stateParams.tab);
    }
  }

  function getCountries() {
    countryService.getAllCountries().then(res => {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function getCustomerById() {
    if (vm.customerId) {
      enableLoading();
      customersService
        .getCustomerById(vm.customerId)
        .then(initCustomer)
        .catch(() => NotificationService.error('Error loading customer data'))
        .finally(disableLoading);
    }
  }

  function initCustomer(res) {
    if (res && res.data) {
      vm.customer = res.data;
      getLocales();
      getSalutations(vm.customer.countryId);
      getCustomerReservations(vm.customer.id);
      getCustomerPoints(vm.customer.id);
      getCustomerRedemptionErrors(vm.customer.id);
    }
  }

  function getLocales() {
    domainService.getLocales().then(function(res) {
      if (res && res.data) {
        vm.options.locales = res.data;
      }
      if (vm.customer.locale && vm.options.locales.indexOf(vm.customer.locale) === -1) {
        vm.options.locales.push(vm.customer.locale);
      }
    });
  }

  function getSalutations(countryId) {
    domainService.getSalutations(countryId).then(function(res) {
      if (res && res.data) {
        vm.options.salutations = res.data;
      }
    });
  }

  function getCustomerReservations(customerId) {
    customersService.getCustomerReservations(customerId, vm.reservationsOffset, vm.limit).then(function(res) {
      if (res && res.data) {
        vm.customerReservations = res.data.reservations;
        vm.customerReservationsTotal = res.data.total;
      }
    });
  }

  function getCustomerPoints(customerId) {
    customersService.getCustomerPoints(customerId, vm.pointsOffset, vm.limit).then(function(res) {
      if (res && res.data) {
        vm.customerPoints = res.data.transfers.items;
        vm.customerPointsTotal = res.data.transfers.total;
        vm.accountBalance = res.data.balance.accountBalance;
        vm.redemptionBalance = res.data.balance.redemptionBalance;
      }
    });
  }

  function getCustomerRedemptionErrors(customerId) {
    customersService.getCustomerRedemptionErrors(customerId, vm.pointsOffset, vm.limit).then(function(res) {
      if (res && res.data) {
        vm.customerRedemptionErrors = res.data.redemptionErrors;
        vm.customerRedemptionErrorsTotal = res.data.total;
      }
    });
  }

  function pointsPageChanged() {
    vm.pointsOffset = vm.currentPointsPage * vm.limit - vm.limit;

    customersService.getCustomerPoints(vm.customer.id, vm.pointsOffset, vm.limit).then(function(res) {
      if (res && res.data) {
        vm.customerPoints = res.data.transfers.items;
      }
    });
  }

  function reservationsPageChanged() {
    vm.reservationsOffset = vm.currentReservationsPage * vm.limit - vm.limit;

    customersService.getCustomerReservations(vm.customerId, vm.reservationsOffset, vm.limit).then(function(res) {
      if (res && res.data) {
        vm.customerReservations = res.data.reservations;
        vm.customerReservationsTotal = res.data.total;
      }
    });
  }

  function redemptionErrorsPageChanged() {
    vm.redemptionErrorsOffset = vm.currentRedemptionErrorsPage * vm.limit - vm.limit;

    customersService.getCustomerRedemptionErrors(vm.customerId, vm.redemptionErrorsOffset, vm.limit).then(function(res) {
      if (res && res.data) {
        vm.customerRedemptionErrors = res.data.redemptionErrors;
        vm.redemptionErrorsTotal = res.data.total;
      }
    });
  }

  function updateCustomer() {
    if (vm.isLoading) {
      return;
    }
    enableLoading();
    customersService
      .updateCustomer(vm.customerId, vm.customer)
      .then(handleSaveSuccess)
      .catch(res => notificationHelper.showError(res, 'Error updating customer'))
      .finally(disableLoading);
  }

  function deleteCustomer() {
    if ($window.confirm('Are you sure you want to delete this customer ?')) {
      enableLoading();
      customersService
        .deleteCustomer(vm.customerId)
        .then(() => {
          NotificationService.success('Customer successfully deleted');
          $state.go('app.customers', {}, { reload: true });
        })
        .catch(res => notificationHelper.showError(res, 'Error deleting customer'))
        .finally(disableLoading);
    }
  }

  function handleSaveSuccess(res) {
    if (res && res.data) {
      NotificationService.success('Customer updated successfully');
      vm.customer = res.data;
    }
  }

  function selectTab(tab) {
    vm.tabs[tab] = true;
  }

  function deselectTab(tab) {
    vm.tabs[tab] = false;
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/customer-update.controller.js